import { createRoutine } from 'redux-saga-routines';
import { USER_LIST, USER_PROFILE, USER_SEARCH } from './actionTypes';

export const getUserList = createRoutine(USER_LIST);
export const getUserSearchList = createRoutine(USER_SEARCH);
export const getUserProfile = createRoutine(USER_PROFILE);
